import { FC } from "react";
import { createStyles, makeStyles, Typography } from "@material-ui/core";
import { get } from "lodash";

import { EssentialImage } from "components";
import { Region } from "services/valuation/types";
import theme from "theme";

import ParagraphContent from "../ParagraphContent";

const useStyles = makeStyles(() =>
  createStyles({
    sectionTitle: {
      fontSize: "1.5rem",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "none",
    },
    iframeWrapper: {
      maxWidth: "550px",
    },
    iframeContainer: {
      position: "relative",
      paddingTop: "56.25%", // 16:9 ratio (9/16 = 0.5625 or 56.25%)
      "& iframe": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      },
    },
  }),
);

const fixedInfoByRegion: Partial<Record<Region, string>> = {
  intl: `<strong>Note.</strong> This catalog will collect international (non-U.S.) earnings only. Domestic (U.S.) earnings are not included in any potential sale or the financial data presented.`,
  domestic: `<strong>Note.</strong> This catalog will collect domestic (U.S.) earnings only. International (non-U.S.) earnings are not included in any potential sale or the financial data presented.`,
};

interface OtherInfoProps {
  otherInfo: string | null;
  regions: Region[];
}

const OtherInfo: FC<OtherInfoProps> = ({ otherInfo, regions }) => {
  const classes = useStyles();

  if (otherInfo) {
    // wraps iframes in a container, Note: this may cause a console warning but we need the `div` elements to achieve a fixed ratio 16:9 layout of the iframe content.
    otherInfo = otherInfo.replace(
      /<iframe/gi,
      `<div class="${classes.iframeWrapper}"><div class="${classes.iframeContainer}"><iframe`,
    );
    otherInfo = otherInfo.replace(/<\/iframe>/gi, "</iframe></div></div>");
  }

  const regionFixedInfo = get(fixedInfoByRegion, regions[0]);

  return !!otherInfo || !!regionFixedInfo ? (
    <>
      <Typography variant="h3" className={classes.sectionTitle} gutterBottom>
        Other Information
      </Typography>
      <ParagraphContent>
        <EssentialImage htmlString={otherInfo} />
      </ParagraphContent>
      {!!regionFixedInfo && (
        <Typography variant="body1" component="div">
          <ParagraphContent>
            <EssentialImage htmlString={regionFixedInfo} />
          </ParagraphContent>
        </Typography>
      )}
    </>
  ) : null;
};

export default OtherInfo;
